export default __webpack_public_path__ + "static/Innovatiive-Digital-Solution-fdb318846c2bc7ed63469e064982d110.png";